<template>
	<section class="image-card">
		<section v-if="!isHighlighted">
			<section class="header" :style="getNormalStyle">
				<div class="category" v-if="tagName">{{ tagName }}</div>
			</section>
			<section class="main">
				<section class="infos">
					<div class="title">{{ title }}</div>
					<div class="desc">{{ desc }}</div>
					<div class="secondary-desc" v-if="secondaryDesc">
						{{ secondaryDesc }}
					</div>
				</section>
				<section class="actions">
					<div v-if="hasMenu">
						<ui-menu-card>
							<slot name="menu"></slot>
						</ui-menu-card>
					</div>
					<ui-button
						design="line-primary md read-more"
						@click="buttonAction(buttonEvent)"
						>{{ buttonText }}</ui-button
					>
				</section>
			</section>
		</section>
		<section v-else>
			<section class="main-highlighted" :style="getHighlightedStyle">
				<section class="header">
					<div class="category" v-if="tagName">{{ tagName }}</div>
				</section>
				<section class="infos">
					<div class="title">{{ title }}</div>
					<div class="desc">{{ desc }}</div>
					<div class="secondary-desc" v-if="secondaryDesc">
						{{ secondaryDesc }}
					</div>
					<div class="actions">
						<ui-button design="primary md large" @click="buttonAction(buttonEvent)">{{
							buttonText
						}}</ui-button>
						<div class="menu-card" v-if="hasMenu">
							<ui-menu-card>
								<slot name="menu"></slot>
							</ui-menu-card>
						</div>
					</div>
				</section>
			</section>
		</section>
	</section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiMenuCard } from '@/components/ui'

	export default {
		components: {
			uiButton,
			uiMenuCard
		},

		name: 'ui-image-card',

		props: {
			/**
			 * Uma URI da imagem a ser usada
			 */
			cover: {
				type: String,
				required: true,
				default: null
			},
			/**
			 * Um título para o card
			 */
			title: {
				type: String,
				required: true,
				default: null
			},
			/**
			 * Uma descrição para o card
			 */
			desc: {
				type: String,
				required: true,
				default: null
			},
			/**
			 * Uma tag a ser mostrada na parta superior do card (só irá aparecer se o valor passado for diferente de null)
			 */
			tagName: {
				type: String,
				required: false,
				default: null
			},
			/**
			 * Uma segunda descrição para o card menos destacada
			 */
			secondaryDesc: {
				type: String,
				required: false,
				default: null
			},
			/**
			 * Estilo do card. Ele é um card destacado ou não?
			 */
			isHighlighted: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Deve aparecer um menu card?
			 */
			hasMenu: {
				type: Boolean,
				required: false,
				default: true
			},
			/**
			 * Texto do botão
			 */
			buttonText: {
				type: String,
				required: false,
				default: 'Ver mais'
			},
			/**
			 * Evento a ser disparado pelo botão
			 */
			buttonEvent: {
				type: String,
				required: false,
				default: 'ui-image-card-button'
			}
		},

		methods: {
			buttonAction(buttonEventName) {
				this.$root.$emit(buttonEventName)
			}
		},

		computed: {
			getValidCover() {
				if (this.cover) return this.cover

				return require('@/assets/imgs/no-image.jpg')
			},

			getNormalStyle() {
				return { backgroundImage: `url('${this.getValidCover}')` }
			},

			getHighlightedStyle() {
				return {
					backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0.8) -0.14%, rgba(0, 0, 0, 0.8) -0.14%, rgba(0, 0, 0, 0) 28.36%, rgba(0, 0, 0, 0) 50.12%, rgba(0, 0, 0, 0) 74.23%, rgba(0, 0, 0, 0.8) 100%), url('${this.getValidCover}')`
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
